module.exports = __webpack_public_path__ + "static/media/ChatbotLogo.01d470d1.svg";